<template>
  <v-select
    v-model="inputedValue"
    item-text="label"
    item-value="value"
    :items="items"
    dense
    outlined
    return-object
    class="original-selectbox"
    hide-details
    :placeholder="$t('common.input_unselected_2')"
    :height="height"
    width="80%"
    :clearable="clearable"
  >
  </v-select>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
export default {
  components: {
    //
  },
  props: {
    value: {
      type: Object,
      require: true,
      default: () => ({})
    },
    height: { default: '32px' },
    clearable: { default: false }
  },
  data: () => ({
    items: []
  }),
  methods: {
    ...mapActions('User', ['getUserListFromApi']),
    ...mapGetters('User', ['getUserListForSelectBox'])
  },
  async created() {
    await this.getUserListFromApi()
    this.items = this.getUserListForSelectBox()
  },
  computed: {
    inputedValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    }
  }
}
</script>
<style scoped lang="scss"></style>
